import { AuthGuard, GuestGuard } from "helpers/auth-guard";
import { ReactElement, ReactNode } from "react";
import { pageAccessType } from "types/index";

function AppLayout({
  children,
  pageAccess,
}: {
  pageAccess?: pageAccessType;
  children: ReactNode;
}): ReactElement<unknown, string> {
  if (pageAccess === "no-auth") {
    return <GuestGuard>{children}</GuestGuard>;
  } else if (pageAccess === "auth") {
    return <AuthGuard>{children}</AuthGuard>;
  }
  return <>{children}</>;
}

export default AppLayout;
